import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import PropTypes from 'prop-types';
import {
  BrowserRouter, Switch, Route, Redirect,
} from 'react-router-dom';
import Login from './components/Login';
import Home from './components/Home';
import PrivateRouteAccess from './PrivateRouteAccess';
import { Users } from './components/users/index';
import { UsersAdmin } from './components/usersAdmin/index';
import { Components } from './components/Components/index';
import { Colleges } from './components/College/index';

function PrivateRoute ({ children, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) => (localStorage.getItem('logged') ? (
        children
      )
        : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        ))}
    />
  );
}
PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

function App () {
  return (
    <div className="body">
      <BrowserRouter>
        <Switch>
          <Route path="/login" component={Login} />
          <PrivateRoute exact path="/">
            <Home />
          </PrivateRoute>
          <PrivateRoute exact path="/users">
            <Users />
          </PrivateRoute>
          <PrivateRoute exact path="/usersadm">
            <UsersAdmin />
          </PrivateRoute>
          <PrivateRouteAccess exact path="/components">
            <Components />
          </PrivateRouteAccess>
          <PrivateRouteAccess exact path="/colleges">
            <Colleges />
          </PrivateRouteAccess>
          <PrivateRoute exact path="*">
            <Home />
          </PrivateRoute>
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
